'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.messagePostSucceeded = messagePostSucceeded;
exports.messagePostFailed = messagePostFailed;
var MESSAGE_POST_REQUESTED = exports.MESSAGE_POST_REQUESTED = 'MESSAGE_POST_REQUESTED';

// An action creator is not required for MESSAGE_POST_REQUESTED, we simply use the
//  MESSAGE_POST_REQUESTED action type as the 'submitAction' in onSubmitActions.
//  (see actions/reduxFormSubmitActions.js for more information)


var MESSAGE_POST_SUCCEEDED = exports.MESSAGE_POST_SUCCEEDED = 'MESSAGE_POST_SUCCEEDED';

function messagePostSucceeded() {
    return {
        type: MESSAGE_POST_SUCCEEDED
    };
}

var MESSAGE_POST_FAILED = exports.MESSAGE_POST_FAILED = 'MESSAGE_POST_FAILED';

function messagePostFailed(errors) {
    return {
        type: MESSAGE_POST_FAILED,
        errors: errors
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/messageActions.js
// module id = 629
// module chunks = 0